<template>
  <transition
    name="slide-fade-left"
    mode="out-in"
  >
    <loader
      v-if="isLoading"
      key="location_loader"
    />
    <div
      v-else
      key="pl_container"
      class="layout-location"
    >
      <div class="location-menu box box-menu pt-4 pr-4 pb-0 pl-4 mb-0 has-background-white-bis">
        <location-topbar />
        <LocationMenu />
      </div>
      <router-view
        :key="'pl_' + $route.name"
        class="is-flex-grow-1"
      />
    </div>
  </transition>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Loader from '../components/UI/Loader.vue'
import { mapGetters } from 'vuex/dist/vuex.common.js';
import LocationEditRight from '../components/Locations/LocationEditRight.vue';
import LocationTopbar from '../components/Locations/LocationTopbar.vue';
import LocationMenu from '../components/Locations/Manage/LocationMenu.vue';
export default {
  components: {
    Loader,
    LocationEditRight,
    LocationTopbar,
    LocationMenu
  },

  props: {
    // pageView: {
    //   type: String,
    //   default: 'locationDetail'
    // }
  },

  data(vm) {
    return {
      channelId: vm.$route.params.channelId
        ? Number(vm.$route.params.channelId)
        : 0,
      locationId: vm.$route.params.locationId
        ? Number(vm.$route.params.locationId)
        : 0,
      isLoading: true
    }
  },

  computed: {
  },

  async created() {
    !isNaN(this.locationId) && await Promise.allSettled([this.getLocationState(this.locationId), this.getLocation(this.locationId)])

    this.isLoading = false
  },

  beforeDestroy() {
    this.setLocation(null)
    this.setLocationState(null)
    this.setVisibleItem('locationDetail')
  },

  methods: {
    ...mapMutations('locationStore', ['setLocation', 'setLocationState']),
    ...mapActions('locationStore', ['getLocationState', 'getLocation']),
  },
}
</script>

<style lang="scss" scoped>
// .layout-location {
//   position: relative;
// }
// .location-menu {
//   position: absolute;
//   top: 0px;
//   left: 0px;
//   right: 0px;
//   margin-top: -13px;
//   margin-left: -13px;
//   margin-right: -13px;
// }
</style>